import React, { useState } from 'react';
import { DatePicker } from 'antd';
import { Dayjs } from 'dayjs';

import {
  QuestionValue,
  SurveyQuestion,
} from '@totem/components/surveyV2/types';
import { ParseDate } from '@totem/utilities/dateUtilities';

const styles = {
  picker: {
    width: '100%',
  },
};

type Props = {
  question: SurveyQuestion;
  disabled: boolean;
  onChange: (value: QuestionValue) => void;
};

const DateQuestion = ({ question, disabled, onChange }: Props) => {
  const [value, setValue] = useState<QuestionValue>(question.value);

  const handleChange = (date: Dayjs | Dayjs[] | null) => {
    // AntD 6: date can be Dayjs | Dayjs[] | null
    const actualDate = Array.isArray(date) ? date[0] : date;

    const newValue: QuestionValue = {
      value: actualDate ? actualDate.toISOString() : '',
      valueInt: actualDate ? actualDate.valueOf() : 0,
      valueFloat: actualDate ? actualDate.valueOf() : 0,
      valueArray: [],
    };

    setValue(newValue);

    onChange(newValue);
  };

  return (
    <DatePicker
      // @ts-ignore
      value={ParseDate(value.valueInt)}
      onChange={handleChange}
      disabled={disabled}
      style={styles.picker}
      size="large"
    />
  );
};

export default DateQuestion;
